import {
  Badge,
  Button,
  Col,
  Form,
  Input,
  Row,
  Select,
  Space,
  Switch,
} from "antd";
import { useEffect, useState } from "react";
import {
  create,
  update,
  getColors,
  getTypes,
} from "../../../services/categories.service";
import { AlertService } from "../../../services/alert.service";
import { useMutation, useQuery } from "react-query";

export default function CategoryForm(props: any) {
  const [colors, setColors] = useState<{ value: String; label: string }[]>([]);
  const [types, setTypes] = useState<{ value: String; label: string }[]>([]);
  const [active, setActive] = useState<boolean>(true);

  const [formCategory] = Form.useForm();

  useQuery(["loadColors"], () => getColors(), {
    onSuccess: (response) => setColors(response.data),
    refetchOnWindowFocus: false,
  });

  useQuery(["loadTypes"], () => getTypes(), {
    onSuccess: (response) => setTypes(response.data),
    refetchOnWindowFocus: false,
  });

  const { mutate: createCategory, isLoading: createCategoryLoading } =
    useMutation(create, {
      onSuccess: () => props.savedForm("Nova categoria gravado com sucesso."),
    });

  const { mutate: updateCategory, isLoading: updateCategoryLoading } =
    useMutation(update, {
      onSuccess: () => props.savedForm("Categoria editada com sucesso."),
    });

  const onSubmit = () => {
    formCategory
      .validateFields()
      .then((values) => {
        if (!props.category) {
          createCategory(values);
        } else {
          updateCategory({ values, id: Number(props.category.id) });
        }
      })
      .catch(() =>
        AlertService.sendAlert([
          { text: "Campo(s) com preenchimento inválido", type: "error" },
        ])
      );
  };

  const onChangeActive = (value: boolean) => {
    setActive(value);
  };

  useEffect(() => {
    if (props.category) {
      formCategory.setFieldsValue(props.category);
      setActive(props.category.active);
    }
  }, [props.category]);

  return (
    <>
      <div>
        <Form
          form={formCategory}
          name="form_table"
          layout="vertical"
          className="form_table"
          autoComplete="off"
          onValuesChange={() => props.onValuesChange(true)}
        >
          <Row gutter={20}>
            <Col span={24}>
              <Form.Item
                label="Nome categoria"
                name="name"
                rules={[{ required: true, message: "Campo obrigatório" }]}
              >
                <Input
                  placeholder="Adiciona nome do categoria"
                  size="large"
                  maxLength={100}
                />
              </Form.Item>
            </Col>

            <Col
              lg={{ span: 12 }}
              md={{ span: 12 }}
              sm={{ span: 24 }}
              xs={{ span: 24 }}
            >
              <Form.Item
                label="Tipo"
                name="type"
                rules={[{ required: true, message: "Campo obrigatório" }]}
              >
                <Select
                  placeholder="Selecione o tipo"
                  size="large"
                  options={types}
                />
              </Form.Item>
            </Col>

            <Col
              lg={{ span: 12 }}
              md={{ span: 12 }}
              sm={{ span: 24 }}
              xs={{ span: 24 }}
            >
              <Form.Item label="Cor" name="color">
                <Select placeholder="Seleciona cor" size="large">
                  {colors
                    .map((color: any) => (
                      <Select.Option key={color.value} value={color.value}>
                        <Badge color={color.value} text={color.label} />
                      </Select.Option>
                    ))}
                </Select>
              </Form.Item>
            </Col>

            <Col span={24}>
              {props.category && (
                <Form.Item
                  label={`Categoria ${active ? "ativa" : "não ativa"}`}
                  name="active"
                >
                  <Switch checked={active} onChange={onChangeActive} />
                </Form.Item>
              )}
            </Col>
          </Row>
        </Form>
      </div>

      <Space>
        <Button
          type="primary"
          loading={createCategoryLoading || updateCategoryLoading}
          size="large"
          onClick={onSubmit}
        >
          Gravar
        </Button>

        <Button
          loading={createCategoryLoading || updateCategoryLoading}
          onClick={() => props.closeForm()}
          size="large"
        >
          Cancelar
        </Button>
      </Space>
    </>
  );
}
